import {
  getAccounts,
  getPolicyForAccount,
} from '../clients/accountClient-deprecated';
import { IAccount, ISession } from '../types';
import findAccountInAccounts from '../util/findAccountInAccounts';
import SessionManager from '../util/SessionManager';
import { getAccountIdFromUrl } from '../util/url';
import { SELECTED_ACCOUNT_LOCAL_STORAGE_KEY } from './constants';
import { ITokenData } from './types';

function getSelectedAccount(accounts: IAccount[]) {
  let selectedAccount;

  const vanityAccountId = getAccountIdFromUrl();
  if (vanityAccountId) {
    selectedAccount = findAccountInAccounts(accounts, vanityAccountId);
  }

  if (!selectedAccount) {
    const storedAccount = localStorage.getItem(
      SELECTED_ACCOUNT_LOCAL_STORAGE_KEY
    );
    if (storedAccount) {
      selectedAccount = findAccountInAccounts(accounts, storedAccount);
    }
  }

  if (!selectedAccount) {
    selectedAccount = accounts[0];
    localStorage.setItem(
      SELECTED_ACCOUNT_LOCAL_STORAGE_KEY,
      selectedAccount.subdomain
    );
  }

  return selectedAccount;
}

export async function createSession(
  tokenData: ITokenData,
  sessionManager: SessionManager
): Promise<ISession | undefined> {
  let accounts;
  try {
    ({ accounts } = await getAccounts(tokenData.accessToken));
  } catch (err) {
    sessionManager._onError(err);
    return;
  }

  let account;
  let policy;
  if (accounts?.length) {
    account = getSelectedAccount(accounts);
    if (account) {
      ({ policy } = await getPolicyForAccount(
        tokenData.accessToken,
        account.id
      ));
    }
  }

  return {
    ...tokenData,
    account,
    accounts: accounts ?? [],
    policy,
  } as ISession;
}
